<vc-page
  *ngIf="userData"
  pageType="landing"
  [userData]="userData"
  [isMdUp]="isMdUp"
  [overwrightPage]="landingPageFromResolver"
  (blockList$)="parseBlockList($event)"
  [updatedBlockList]="updatedBlockList"
  [pageParam]="pageParam"
  (onTrackClick)="onTrackClick($event)"
  (onTrackView)="onTrackView($event)"
  (openPopin)="openPopin($event)"
>
  <vc-catalog
    *ngIf="configCatalogArray[0]"
    [config]="configCatalogArray[0]"
    [likedItem]="likedItem"
    pageType="landing"
    catalog-product-one
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[1]"
    [config]="configCatalogArray[1]"
    [likedItem]="likedItem"
    pageType="landing"
    catalog-product-two
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[2]"
    [config]="configCatalogArray[2]"
    [likedItem]="likedItem"
    pageType="landing"
    catalog-product-three
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[3]"
    [config]="configCatalogArray[3]"
    [likedItem]="likedItem"
    pageType="landing"
    catalog-product-four
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[4]"
    [config]="configCatalogArray[4]"
    [likedItem]="likedItem"
    pageType="landing"
    catalog-product-five
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[5]"
    [config]="configCatalogArray[5]"
    [likedItem]="likedItem"
    pageType="landing"
    catalog-product-six
  ></vc-catalog>
</vc-page>
